module.exports = __webpack_public_path__ + "img/logo-inverted.62580cc2.svg";